import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.snowflakePushDataProgress;

const SnowflakePushDataProgressData = createSelector([selector], (state) => state);

export default {
  SnowflakePushDataProgressData
};